import { render, staticRenderFns } from "./_PageSubMenuPending.vue?vue&type=template&id=42b43ba4&"
import script from "./_PageSubMenuPending.vue?vue&type=script&lang=js&"
export * from "./_PageSubMenuPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports